import { AlmdedalenIcon } from "@/components/almedalen-icon";
import { Link } from "react-router-dom";

function LoginHeader() {
  return (
    <header className="w-full bg-gray border-b border-input">
      <div className="max-w-[1440px] px-4 lg:px-6 flex items-center h-[80px]">
        <Link to="/">
          <AlmdedalenIcon className="h-[60px] w-auto hidden lg:block" />
          <AlmdedalenIcon className="h-10 w-auto lg:hidden block" />
        </Link>
      </div>
    </header>
  );
}

export default LoginHeader;